import { createReducer, on } from '@ngrx/store';
import {
  handleClear,
  handleFailure,
  handleRequest,
  handleSuccess,
} from '@shared/ngrx-factory/factory.reducer';
import {
  PrequalificationWindowNoticePdfResponse,
  PrequalificationWindowResponse,
  EnrollToPrequalificationData,
  EnrollToPrequalificationResponse,
} from '../responses/prequalification-window.response';
import {
  PrequalificationWindowActions,
  PrequalificationWindowNoticePdfActions,
  EnrollPrequalificationActions,
  PrequalificationForCurrentWindowActions,
  PrequalificationByUuidActions,
  SupplierPaymentActions,
  AttendSupplierCheckListItemActions,
  SubmitSupplierPrequalificationActions,
} from './supplier-registration.action';
import { PrequalificationData } from '../responses/current-window-prequalification.respomse';
import { GenerateControlNumberResponse } from '@modules/registration/omc-registration/responses/generate,control-number.response';
import { ChecklistItemData } from '../responses/attend-checklist-item.response';
import { SubmitSupplierPrequalificationData } from '../responses/submit-supplier-prequalification.response';

export interface SupplierRegistrationState {
  prequalificationWindow: RequestState<PrequalificationWindowResponse>;
  prequalificationWindowNoticePdf: RequestState<PrequalificationWindowNoticePdfResponse>; // Base64 encoded PDF data
  enrollPrequalification: RequestState<EnrollToPrequalificationData>;
  prequalificationForCurrentWindow: RequestState<PrequalificationData>;
  prequalificationByUuid: RequestState<PrequalificationData>;
  generateControlNumber: RequestState<GenerateControlNumberResponse['generateControlNumber']>;
  attendSupplierCheckListItem: RequestState<ChecklistItemData>;
  submitSupplierPrequalification: RequestState<SubmitSupplierPrequalificationData | null>;
}

export interface RequestState<T = any> {
  loading: boolean;
  response: T | null;
  error: any | null;
}

export const initialSupplierRegistrationState: SupplierRegistrationState = {
  prequalificationWindow: { loading: false, response: null, error: null },
  prequalificationWindowNoticePdf: { loading: false, response: null, error: null },
  enrollPrequalification: { loading: false, response: null, error: null },
  prequalificationForCurrentWindow: { loading: false, response: null, error: null },
  prequalificationByUuid: { loading: false, response: null, error: null },
  generateControlNumber: { loading: false, response: null, error: null },
  attendSupplierCheckListItem: { loading: false, response: null, error: null },
  submitSupplierPrequalification: { loading: false, response: null, error: null },
};

export const supplierRegistrationReducer = createReducer(
  initialSupplierRegistrationState,

  on(PrequalificationWindowActions.request, (state) =>
    handleRequest(state, 'prequalificationWindow'),
  ),
  on(PrequalificationWindowActions.success, (state, { response }) =>
    handleSuccess(state, 'prequalificationWindow', response),
  ),
  on(PrequalificationWindowActions.failure, (state, { error }) =>
    handleFailure(state, 'prequalificationWindow', error),
  ),
  on(PrequalificationWindowActions.clearState, (state) =>
    handleClear(state, 'prequalificationWindow'),
  ),
  on(PrequalificationWindowNoticePdfActions.request, (state) =>
    handleRequest(state, 'prequalificationWindowNoticePdf'),
  ),
  on(PrequalificationWindowNoticePdfActions.success, (state, { response }) =>
    handleSuccess(state, 'prequalificationWindowNoticePdf', response),
  ),
  on(PrequalificationWindowNoticePdfActions.failure, (state, { error }) =>
    handleFailure(state, 'prequalificationWindowNoticePdf', error),
  ),
  on(EnrollPrequalificationActions.request, (state) =>
    handleRequest(state, 'enrollPrequalification'),
  ),
  on(EnrollPrequalificationActions.success, (state, { response }) =>
    handleSuccess(state, 'enrollPrequalification', response),
  ),
  on(EnrollPrequalificationActions.failure, (state, { error }) =>
    handleFailure(state, 'enrollPrequalification', error),
  ),
  on(EnrollPrequalificationActions.clearState, (state) =>
    handleClear(state, 'enrollPrequalification'),
  ),

  on(PrequalificationForCurrentWindowActions.request, (state) =>
    handleRequest(state, 'prequalificationForCurrentWindow'),
  ),
  on(PrequalificationForCurrentWindowActions.success, (state, { response }) =>
    handleSuccess(state, 'prequalificationForCurrentWindow', response),
  ),
  on(PrequalificationForCurrentWindowActions.failure, (state, { error }) =>
    handleFailure(state, 'prequalificationForCurrentWindow', error),
  ),
  on(PrequalificationForCurrentWindowActions.clearState, (state) =>
    handleClear(state, 'prequalificationForCurrentWindow'),
  ),

  on(PrequalificationByUuidActions.request, (state) => handleRequest(state, 'prequalificationByUuid')),
  on(PrequalificationByUuidActions.success, (state, { response }) =>
    handleSuccess(state, 'prequalificationByUuid', response),
  ),
  on(PrequalificationByUuidActions.failure, (state, { error }) =>
    handleFailure(state, 'prequalificationByUuid', error),
  ),
  on(PrequalificationByUuidActions.clearState, (state) =>
    handleClear(state, 'prequalificationByUuid'),
  ),

  on(SupplierPaymentActions.request, (state) => handleRequest(state, 'generateControlNumber')),
  on(SupplierPaymentActions.success, (state, { response }) =>
    handleSuccess(state, 'generateControlNumber', response),
  ),
  on(SupplierPaymentActions.failure, (state, { error }) =>
    handleFailure(state, 'generateControlNumber', error),
  ),
  on(SupplierPaymentActions.clearState, (state) => handleClear(state, 'generateControlNumber')),

  on(AttendSupplierCheckListItemActions.request, (state) =>
    handleRequest(state, 'attendSupplierCheckListItem'),
  ),
  on(AttendSupplierCheckListItemActions.success, (state, { response }) =>
    handleSuccess(state, 'attendSupplierCheckListItem', response),
  ),
  on(AttendSupplierCheckListItemActions.failure, (state, { error }) =>
    handleFailure(state, 'attendSupplierCheckListItem', error),
  ),
  on(AttendSupplierCheckListItemActions.clearState, (state) =>
    handleClear(state, 'attendSupplierCheckListItem'),
  ),

  on(SubmitSupplierPrequalificationActions.request, (state) =>
    handleRequest(state, 'submitSupplierPrequalification'),
  ),
  on(SubmitSupplierPrequalificationActions.success, (state, { response }) =>
    handleSuccess(state, 'submitSupplierPrequalification', response),
  ),
  on(SubmitSupplierPrequalificationActions.failure, (state, { error }) =>
    handleFailure(state, 'submitSupplierPrequalification', error),
  ),
  on(SubmitSupplierPrequalificationActions.clearState, (state) =>
    handleClear(state, 'submitSupplierPrequalification'),
  ),
);
